import {NgModule} from "@angular/core";
import {LoginComponent} from "./component/login-component/login.component";
import {CheckboxModule} from "primeng/checkbox";
import {ButtonModule} from "primeng/button";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {InputTextModule} from "primeng/inputtext";
import {SidebarModule} from "primeng/sidebar";
import {BadgeModule} from "primeng/badge";
import {RadioButtonModule} from "primeng/radiobutton";
import {InputSwitchModule} from "primeng/inputswitch";
import {RippleModule} from "primeng/ripple";
import {RouterModule} from "@angular/router";
import {CorePage} from "./page/core-page/core.page";
import {CoreComponent} from "./component/core-component/core.component";
import {PasswordModule} from "primeng/password";
import {CommonModule} from "@angular/common";
import {PanelModule} from "primeng/panel";
import {StepperComponent} from "./component/stepper-component/stepper.component";
import {TableModule} from "primeng/table";
import {TagModule} from "primeng/tag";
import {MessageModule} from "primeng/message";
import {DialogModule} from "primeng/dialog";
import {MessagesModule} from "primeng/messages";
import {FormComponent} from "./component/form-component/form.component";
import {DropdownModule} from "primeng/dropdown";
import {InputNumberModule} from "primeng/inputnumber";
import {CalendarModule} from "primeng/calendar";
import {InputTextareaModule} from "primeng/inputtextarea";
import {OtpComponent} from "./component/otp/otp.component";
import {
  ForgetPasswordRequestComponent
} from "./component/forget-password-request-options/forget-password-request.component";
import {ForgetPasswordOtpComponent} from "./component/forget-password-otp/forget-password-otp.component";
import {ForgetPasswordPage} from "./page/forget-password-page/forget-password.page";
import {
  ForgetPasswordChangePasswordComponent
} from "./component/forget-password-change-password/forget-password-change-password.component";
import {AvatarModule} from "primeng/avatar";
import {CoreUploadComponent} from "./component/core-upload/core-upload.component";
import {AppPdfViewComponent} from "./component/app-pdf-view/app-pdf-view.component";
import {FileUploadModule} from "primeng/fileupload";
import {TreeSelectModule} from "primeng/treeselect";
import {TooltipModule} from "primeng/tooltip";
import {KeyFilterModule} from "primeng/keyfilter";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {AppButtonComponent} from "./component/app-button/app-button.component";
import {NewlinePipe} from "./pipes/new-line.pipe";
import {NgOtpInputModule} from "ng-otp-input";
import {ContextMenuModule} from "primeng/contextmenu";
import {ImageCropperModule} from "ngx-image-cropper";
import {LoginOtpCodePage} from "./page/login-otp-code-page/login-otp-code-page";
import {LoginOtpRequestComponent} from "./component/login-otp-request-options/login-otp-request.component";
import {LoginOtpEmailComponent} from "./component/login-otp-email/login-otp-email.component";
import {LoginOtpPhoneComponent} from "./component/login-otp-phone/login-otp-phone.component";
import {LoginOtpFieldComponent} from "./component/login-otp-field/login-otp-field.component";
import {LoginWithPasscodeComponent} from "./component/login-with-passcode-component/login-with-passcode.component";
import {LoginWithTokenComponent} from "./component/login-with-token-component/login-with-token.component";


@NgModule({
  declarations: [
    LoginComponent,
    CorePage,
    CoreComponent,
    StepperComponent,
    FormComponent,
    OtpComponent,
    ForgetPasswordRequestComponent,
    ForgetPasswordOtpComponent,
    ForgetPasswordPage,
    ForgetPasswordChangePasswordComponent,
    CoreUploadComponent,
    AppPdfViewComponent,
    AppButtonComponent,
    NewlinePipe,
    LoginOtpCodePage,
    LoginOtpRequestComponent,
    LoginOtpEmailComponent,
    LoginOtpPhoneComponent,
    LoginOtpFieldComponent,
    LoginWithPasscodeComponent,
    LoginWithTokenComponent

  ],
  exports: [
    LoginComponent,
    CorePage,
    CoreComponent,
    CheckboxModule,
    ButtonModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    RouterModule,
    CommonModule,
    PanelModule,
    ReactiveFormsModule,
    DialogModule,
    StepperComponent,
    TableModule,
    TagModule,
    MessageModule,
    MessagesModule,
    FormComponent,
    InputTextModule,
    DropdownModule,
    InputNumberModule,
    CalendarModule,
    InputTextareaModule,
    OtpComponent,
    ForgetPasswordRequestComponent,
    ForgetPasswordOtpComponent,
    ForgetPasswordPage,
    ForgetPasswordChangePasswordComponent,
    AvatarModule,
    CoreUploadComponent,
    AppPdfViewComponent,
    TooltipModule,
    AppButtonComponent,
    NewlinePipe,
    ContextMenuModule,
    FileUploadModule,

    ImageCropperModule,
    LoginOtpCodePage,
    LoginOtpRequestComponent,
    LoginOtpEmailComponent,
    LoginOtpPhoneComponent,
    LoginOtpFieldComponent,
    LoginWithPasscodeComponent,
    LoginWithTokenComponent
  ],
  imports: [
    CommonModule,
    InputTextModule,
    DropdownModule,
    InputNumberModule,
    CalendarModule,
    CheckboxModule,
    ButtonModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    RippleModule,
    RouterModule,
    PanelModule,
    PasswordModule,
    ReactiveFormsModule,
    TableModule,
    TagModule,
    MessageModule,
    DialogModule,
    AvatarModule,
    MessagesModule,
    InputTextareaModule,
    FileUploadModule,
    TreeSelectModule,
    TooltipModule,
    KeyFilterModule,
    ProgressSpinnerModule,
    ContextMenuModule,
    FileUploadModule,

    NgOtpInputModule,

    ImageCropperModule,

  ]
})
export class CoreModule {
}
